export default function normalizeReferenceCountries(countries) {
  if (!Array.isArray(countries)) return [];

  return countries
    .map((country) => ({
      code: (country?.iso2 ?? country?.Iso2 ?? country?.code ?? country?.Code ?? '').toUpperCase(),
      name: country?.name ?? country?.Name ?? country?.iso2 ?? country?.Iso2 ?? '',
    }))
    .filter((country) => country.code)
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}
